module.exports = __webpack_public_path__ + "static/media/CTLI_2-235w.aed6e79d.webp";